import axios from 'axios';

const API_BASE_URL = window.location.origin == 'http://localhost:3000' ? process.env.REACT_APP_API_URL : process.env.REACT_APP_DEV_API_URL;
console.log('API_BASE_URL', API_BASE_URL, process.env, window.location.origin, process.env.REACT_APP_API_URL, process.env.REACT_APP_DEV_API_URL);
// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // No need for withCredentials since we're using localStorage
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      //window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  // Email login
  loginWithEmail: async (email, password) => {
    const response = await api.post('/api/auth/login', { email, password });
    return response.data;
  },

  // Google login
  loginWithGoogle: async (googleToken) => {
    const response = await api.post('/api/auth/google', { token: googleToken });
    return response.data;
  },

  // Register
  register: async (email, password, name) => {
    const response = await api.post('/api/auth/register', { email, password, name });
    return response.data;
  },

  // Logout
  logout: async () => {
    const response = await api.post('/api/auth/logout');
    return response.data;
  },

  // Get user profile
  getProfile: async () => {
    const response = await api.get('/api/auth/profile');
    return response.data;
  },

  // API Keys management
  getApiKeys: async () => {
    const response = await api.get('/api/settings/api-keys');
    return response.data;
  },

  saveApiKeys: async (apiKeys) => {
    const response = await api.post('/api/settings/api-keys', apiKeys);
    return response.data;
  },
};

export default api;
